import React, { useState, useEffect } from 'react';
import SavedParameterCard from './SavedParameterCard';
import '../styles/MobileScreener.css';

function ScreenerSavedParams({
  savedParams,
  onLoad,
  onDelete,
  onAddToQueue,
  forceCollapsed = false, // External control to collapse
  collapseSignal = 0, // Bumped counter: collapse once per bump (see below)
  compact = false, // Use compact styling (for mobile)
  maxContentHeight = null // Max height for scrollable cards container (desktop)
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Collapse when forceCollapsed changes to true
  useEffect(() => {
    if (forceCollapsed) {
      setIsExpanded(false);
    }
  }, [forceCollapsed]);

  // forceCollapsed is a one-way latch, so it can't fire again once true — e.g.
  // picking a second ticker. A bumped counter (same idiom as ScreenerQueue's
  // expandSignal) collapses on every bump while leaving the card user-operable
  // in between. Callers that don't pass it are unaffected.
  useEffect(() => {
    if (collapseSignal > 0) {
      setIsExpanded(false);
    }
  }, [collapseSignal]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`saved-params-section ${compact ? 'compact' : ''} ${isExpanded ? 'expanded' : ''}`}>
      <div
        className="collapsible-header"
        onClick={toggleExpanded}
      >
        <div className="collapsible-header-left">
          <span className={`chevron ${isExpanded ? 'rotate-90' : ''}`}>
            ›
          </span>
          <h3>Saved Parameters</h3>
          {!isExpanded && savedParams.length > 0 && (
            <span className="saved-params-count">{savedParams.length} saved</span>
          )}
        </div>
      </div>

      {isExpanded && (
        <>
          {savedParams.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">💾</div>
              <div className="empty-state-text">
                No saved parameters yet. Save your favorite configurations for quick reuse.
              </div>
            </div>
          ) : (
            <div className="saved-params-list-container">
              <div className="saved-params-list">
                {savedParams.map((param) => (
                  <SavedParameterCard
                    key={param.id}
                    param={param}
                    onQueue={onAddToQueue}
                    onLoad={onLoad}
                    onDelete={onDelete}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ScreenerSavedParams;
